import { ReactComponent as CoinsBambooLogoSmall } from "./logo-small.svg";

const LogoSmall: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
> = ({ style, ...props }) => (
  <CoinsBambooLogoSmall
    {...props}
    style={{
      display: "block",
      width: "20px",
      maxWidth: "100%",
      height: "auto",
      ...style,
    }}
  />
);

export default LogoSmall;
